module.exports = __webpack_public_path__ + "static/media/cs.e7b8fcd4.png";